module.exports = __webpack_public_path__ + "static/notion-5c400ba5b130d10089a3a77ae6cda8d7.png";